import React from 'react'
import { MDXTag } from '@mdx-js/tag'


const layoutProps = {};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props);
    this.layout = null;
  }

  render() {
    const {
      components,
      ...props
    } = this.props;
    return <MDXTag name="wrapper" components={components}><MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{
          "href": "/snippets/main/gatsby-files-sourcing/",
          "title": "file sourcing, Gatsby plugin"
        }}>{`A snippet`}</MDXTag>{` with a configuration to source files from a `}<MDXTag name="em" components={components} parentName="p">{`path`}</MDXTag>{` directory.`}</MDXTag>
      <MDXTag name="pre" components={components}><MDXTag name="code" components={components} parentName="pre" props={{
          "className": "language-javascript"
        }}>{`// file sourcing in gatsby-config.js
plugins: [
    {
        resolve: "gatsby-source-filesystem", // a filesystem plugin
        options: {
          name,
          path
        }
    },
]
`}</MDXTag></MDXTag>
           </MDXTag>;
  }

}
export const _frontmatter = {
  "title": "File sourcing",
  "keywords": "file sourcing, Gatsby plugin",
  "menu": "gatsby/files sourcing"
};
    